export default {
    "name": "HomeWorkOrders",
    "kind": "HoudiniQuery",
    "hash": "5b810676078df0699b28847cb0e52c29d055265f27a8f8e30335ba60fe94c19b",

    "raw": `query HomeWorkOrders($filter: WorkOrderFilter, $workOrderTypeFilter: WorkOrderTypeFilter) {
  workOrders(filter: $filter) {
    items {
      store {
        id
      }
      workOrderId
      date
      type {
        name
        id
      }
      user {
        name
        id
      }
      total
      totalJobPartQuantity
      totalJobPartQuantityMissing
      totalJobPartQuantityReady
      jobCount
      totalJobsDone
      notes
      description
      datePromised
      closed
      jobs {
        status
        id
      }
      id
    }
  }
  workOrderTypes(filter: $workOrderTypeFilter) {
    items {
      name
      id
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "workOrders": {
                "type": "WorkOrderList",
                "keyRaw": "workOrders(filter: $filter)",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "WorkOrder",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "store": {
                                        "type": "Store",
                                        "keyRaw": "store",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "workOrderId": {
                                        "type": "UInt",
                                        "keyRaw": "workOrderId",
                                        "visible": true
                                    },

                                    "date": {
                                        "type": "Date",
                                        "keyRaw": "date",
                                        "visible": true
                                    },

                                    "type": {
                                        "type": "WorkOrderType",
                                        "keyRaw": "type",

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "user": {
                                        "type": "UserAccount",
                                        "keyRaw": "user",

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "total": {
                                        "type": "Decimal2",
                                        "keyRaw": "total",
                                        "visible": true
                                    },

                                    "totalJobPartQuantity": {
                                        "type": "Decimal6",
                                        "keyRaw": "totalJobPartQuantity",
                                        "visible": true
                                    },

                                    "totalJobPartQuantityMissing": {
                                        "type": "Decimal6",
                                        "keyRaw": "totalJobPartQuantityMissing",
                                        "visible": true
                                    },

                                    "totalJobPartQuantityReady": {
                                        "type": "Decimal6",
                                        "keyRaw": "totalJobPartQuantityReady",
                                        "visible": true
                                    },

                                    "jobCount": {
                                        "type": "UInt",
                                        "keyRaw": "jobCount",
                                        "visible": true
                                    },

                                    "totalJobsDone": {
                                        "type": "UInt",
                                        "keyRaw": "totalJobsDone",
                                        "visible": true
                                    },

                                    "notes": {
                                        "type": "String",
                                        "keyRaw": "notes",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "visible": true
                                    },

                                    "datePromised": {
                                        "type": "Date",
                                        "keyRaw": "datePromised",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "closed": {
                                        "type": "Boolean",
                                        "keyRaw": "closed",
                                        "visible": true
                                    },

                                    "jobs": {
                                        "type": "Job",
                                        "keyRaw": "jobs",

                                        "selection": {
                                            "fields": {
                                                "status": {
                                                    "type": "JobStatus",
                                                    "keyRaw": "status",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "workOrderTypes": {
                "type": "WorkOrderTypeList",
                "keyRaw": "workOrderTypes(filter: $workOrderTypeFilter)",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "WorkOrderType",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "WorkOrderFilter",
            "workOrderTypeFilter": "WorkOrderTypeFilter"
        },

        "types": {
            "DateFilter": {
                "eq": "Date",
                "gt": "Date",
                "gte": "Date",
                "lt": "Date",
                "lte": "Date",
                "ne": "Date"
            },

            "StoreFilter": {
                "id": "UInt",
                "name": "String"
            },

            "WorkOrderTypeFilter": {
                "active": "Boolean",
                "id": "UInt",
                "name": "String"
            },

            "UserAccountFilter": {
                "authorizedStores": "UInt",
                "id": "UInt",
                "isSalesPerson": "Boolean",
                "name": "String",
                "status": "UserAccountStatusEnum"
            },

            "WorkOrderFilter": {
                "closed": "Boolean",
                "date": "DateFilter",
                "dateClosed": "DateFilter",
                "dateCreated": "DateFilter",
                "isEstimate": "Boolean",
                "store": "StoreFilter",
                "type": "WorkOrderTypeFilter",
                "user": "UserAccountFilter",
                "void": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=00bb5b6f5113bc7b447ca933a27e45ca001b961bfb1530c2c7bfefe689b041b4";